import styled from 'styled-components'
import { Link } from 'react-router-dom'

const SeeAll = styled(Link)`
  color: #248B63;
  font-weight: bold;
  margin-top: 16px;
  font-size: 16px;
  &:hover {
    color: #29b27b;
  }
`
export const Anchor = {
  SeeAll,
}



// WEBPACK FOOTER //
// ./src/styled/anchor.js